import { render, staticRenderFns } from "./PharmacistUpdateNewUI.vue?vue&type=template&id=2e01672b&scoped=true&"
import script from "./PharmacistUpdateNewUI.vue?vue&type=script&lang=ts&"
export * from "./PharmacistUpdateNewUI.vue?vue&type=script&lang=ts&"
import style0 from "./PharmacistUpdateNewUI.vue?vue&type=style&index=0&id=2e01672b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e01672b",
  null
  
)

export default component.exports